export const FILTER_TYPE_BOOL = 'bool';
export const FILTER_TYPE_RADIO = 'radio';
export const FILTER_TYPE_RADIO_ENUM = 'radio_enum';
export const FILTER_TYPE_DATE_RANGE = 'date_range';
export const FILTER_TYPE_DATE_ONLY_RANGE = 'date_only_range';
export const FILTER_TYPE_DATE_MONTH = 'date_month';
export const FILTER_TYPE_DATE_MONTH_RANGE = 'date_month_range';
export const FILTER_TYPE_FULLTEXT = 'fulltext';
export const FILTER_TYPE_MULTI_SELECT = 'multi_select';
export const FILTER_TYPE_MULTI_SELECT_ASYNC = 'multi_select_async';
export const FILTER_TYPE_HIERARCHY = 'hierarchy';
export const FILTER_TYPE_HIERARCHY_MULTI_SELECT = 'hierarchy_multi_select';
export const FILTER_TYPE_MEDICATIONS = 'medications';
export const FILTER_TYPE_ORGANIZATION = 'organization';
export const FILTER_TYPE_AGENS = 'agens';
export const FILTER_TYPE_NUMBER = 'number';
export const FILTER_TYPE_NUMBER_RANGE = 'number_range';
export const FILTER_TYPE_SELECT = 'select';
export const FILTER_TYPE_SELECT_ENUM = 'select_enum';
export const FILTER_TYPE_MULTI_SELECT_ENUM = 'multi_select_enum';
export const FILTER_TYPE_SELECT_ASYNC = 'select_async';
export const FILTER_TYPE_TEXT = 'text';
export const FILTER_TYPE_UNKNOWN = 'unknown';
